import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { AIDisclosureModel, AIDisclosureModelImpl } from './model/ai-disclosure.model';
import { AIDisclosureService, AIDisclosureServiceImpl } from './service/ai-disclosure.service';
import { AIDisclosureResultModel, AIDisclosureResultModelImpl } from './model/ai-disclosure-result.model';
import { AIDisclosureResultService, AIDisclosureResultServiceImpl } from './service/ai-disclosure-result.service';
import {
    ExportDisclosureDTO,
    GetDisclosureContentDTO,
    GetDisclosureTitleDTO,
    GetTechMeansDTO,
    PutDisclosureSettingDTO,
    InitDisclosureSettingDTO,
    PutTechMeansDTO,
    GetDisclosureHistoryDetailDTO,
    GetContentStorageDTO,
} from './service/ai-disclosure.repository.interface';
import { ExportDisclosureDTOImpl } from './repository/export-disclosure.dto';
import { GetDisclosureContentDTOImpl } from './repository/get-disclosure-content.dto';
import { GetDisclosureTitleDTOImpl } from './repository/get-disclosure-title.dto';
import { GetTechMeansDTOImpl } from './repository/get-tech-means.dto';
import { PutDisclosureSettingDTOImpl } from './repository/put-disclosure-setting.dto';
import { InitDisclosureSettingDTOImpl } from './repository/init-disclosure-setting.dto';
import { PutTechMeansDTOImpl } from './repository/put-tech-means.dto';
import { GetDisclosureHistoryDetailDTOImpl } from './repository/get-disclosure-history-detail.dto';
import { GetContentStorageDTOImpl } from './repository/get-content-storage.dto';

export const AIDisclosureModule = (bind: interfaces.Bind) => {
    bind(AIDisclosureModel).to(AIDisclosureModelImpl);
    bind(AIDisclosureService).to(AIDisclosureServiceImpl);
    bind(AIDisclosureResultModel).to(AIDisclosureResultModelImpl);
    bind(AIDisclosureResultService).to(AIDisclosureResultServiceImpl);

    bind(ExportDisclosureDTO).to(ExportDisclosureDTOImpl);
    bind(GetDisclosureContentDTO).to(GetDisclosureContentDTOImpl);
    bind(GetDisclosureTitleDTO).to(GetDisclosureTitleDTOImpl);
    bind(GetTechMeansDTO).to(GetTechMeansDTOImpl);
    bind(PutDisclosureSettingDTO).to(PutDisclosureSettingDTOImpl);
    bind(InitDisclosureSettingDTO).to(InitDisclosureSettingDTOImpl);
    bind(PutTechMeansDTO).to(PutTechMeansDTOImpl);
    bind(GetDisclosureHistoryDetailDTO).to(GetDisclosureHistoryDetailDTOImpl);
    bind(GetContentStorageDTO).to(GetContentStorageDTOImpl);
};
